export default __webpack_public_path__ + "static/flyerBackThumbnail-2938e04a3254372b52f1a0b0f99a4e1c.jpg";